import styled from "styled-components";
import { Link } from "react-router-dom";

export const Sekcja = styled.footer`
  background: #fff;
  border-top: 1px solid #e5e8e3;
`;

export const Glowna = styled.div`
  max-width: 1180px;
  margin: 0 auto;
  padding: 22px clamp(16px, 5vw, 50px);
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;

  @media (max-width: ${({ theme }) => theme.breakpoint.mobileMax}px) {
    padding: 20px 8px;
    text-align: center;
    justify-content: center;
  }
`;

export const Logo = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;

  > img { width: 210px; height: auto; }

  @media (max-width: ${({ theme }) => theme.breakpoint.mobileMax}px) {
    margin-top: 0;
    flex-direction: column;
    align-items: center;
    
    gap: 10px;
  }
`;

export const Icon = styled.img`
  margin: 7px;
  width: 34px;
  height: 34px;
`;

export const Hyperlink = styled.a`
  text-decoration: none;
  display: flex;
  flex-direction: row;
  align-items: center;
  text-align: left;

  &:hover {
    text-decoration: underline;
  }

  @media (max-width: ${({ theme }) => theme.breakpoint.tabletMax}px) {
    font-size: smaller;
  }
`;

export const Container = styled.div`
  display: flex;
`;

export const Stopka = styled.div`
  padding: 8px clamp(16px, 5vw, 50px);
  background-color: ${({ theme }) => theme.color.black};
  color: ${({ theme }) => theme.color.orange};
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;

  @media (max-width: ${({ theme }) => theme.breakpoint.mobileMax}px) {
    justify-content: center;
    padding: 14px 16px;
    text-align: center;
    gap: 4px;
  }
`;

export const Linki = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  @media (max-width: 620px) { width:100%; flex-direction:column; gap:0; > p { display:none; } a { min-height:44px; display:flex; align-items:center; justify-content:center; white-space:nowrap; } }
`;

export const StyledLink = styled(Link)`
  text-decoration: none;
  color: ${({ theme }) => theme.color.white};

  &:hover {
    text-decoration: underline;
  }

  @media (max-width: ${({ theme }) => theme.breakpoint.mobileMax}px) {
    align-self: center;
  }
`;

